// this module seems to be simple enough; no need to write tests

export const UI_OVERLAY_MODE_TOGGLED = "UI_OVERLAY_MODE_TOGGLED";
const UI_PREVIOUS_DETAILED_DEM_DIFF_VISIBILITY_TOGGLED =
  "UI_PREVIOUS_DETAILED_DEM_DIFF_VISIBILITY_TOGGLED";
const UI_PENULT_DETAILED_DEM_DIFF_VISIBILITY_TOGGLED =
  "UI_PENULT_DETAILED_DEM_DIFF_VISIBILITY_TOGGLED";
const UI_DETAILED_DEM_WITH_DG_DIFF_VISIBILITY_TOGGLED =
  "UI_DETAILED_DEM_WITH_DG_DIFF_VISIBILITY_TOGGLED";
export const UI_GCP_VISIBILITY_ENABLED = "UI_GCP_VISIBILITY_ENABLED";
export const UI_GCP_VISIBILITY_DISABLED = "UI_GCP_VISIBILITY_DISABLED";
export const UI_QC_VISIBILITY_ENABLED = "UI_QC_VISIBILITY_ENABLED";
export const UI_ARCHIVE_VISIBILITY_DISABLED = "UI_ARCHIVE_VISIBILITY_DISABLED";
export const UI_EXISTING_VISIBILITY_TOGGLED = "UI_EXISTING_VISIBILITY_TOGGLED";
export const UI_EXISTING_VISIBILITY_ENABLED = "UI_EXISTING_VISIBILITY_ENABLED";
export const UI_PROBLEM_VISIBILITY_TOGGLED = "UI_PROBLEM_VISIBILITY_TOGGLED";
export const UI_PROBLEM_VISIBILITY_ENABLED = "UI_PROBLEM_VISIBILITY_ENABLED";
export const UI_ALL_VISIBILITY_TOGGLED = "UI_ALL_VISIBILITY_TOGGLED";
export const UI_SHOW_FLIGHT_MARKER_LABELS_TOGGLED =
  "UI_SHOW_FLIGHT_MARKER_LABELS_TOGGLED";
export const UI_ALL_VISIBILITY_ENABLED = "UI_ALL_VISIBILITY_ENABLED";
export const UI_GCP_RADIUS_TOGGLED = "UI_GCP_RADIUS_TOGGLED";
export const UI_NEW_NAIL_ADDITION_TOGGLED = "UI_NEW_NAIL_ADDITION_TOGGLED";
export const UI_NEW_NAIL_ADDITION_DISABLED = "UI_NEW_NAIL_ADDITION_DISABLED";
export const UI_MAIL_COMPOSER_GCP_VISIBILITY_TOGGLED =
  "UI_MAIL_COMPOSER_GCP_VISIBILITY_TOGGLED";
export const UI_SIDEBAR_VISIBILITY_TOGGLED = "UI_SIDEBAR_VISIBILITY_TOGGLED";

export const UI_ACTIVE_NAIL_SELECTED = "UI_ACTIVE_NAIL_SELECTED";
export const selectActiveNail = (nailId: string): IAction<string> => ({
  payload: nailId,
  type: UI_ACTIVE_NAIL_SELECTED,
});

const UI_FLIGHT_MARKER_ACTIONS_MENU_HIDDEN =
  "UI_FLIGHT_MARKER_ACTIONS_MENU_HIDDEN";
export const hideFlightMarkerActionsMenu = (): IAction<void> => ({
  type: UI_FLIGHT_MARKER_ACTIONS_MENU_HIDDEN,
  payload: undefined,
});

export const toggleOverlayMode = (): IAction<void> => ({
  payload: null,
  type: UI_OVERLAY_MODE_TOGGLED,
});

export const togglePreviousDetailedDemDiffVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_PREVIOUS_DETAILED_DEM_DIFF_VISIBILITY_TOGGLED,
});

export const togglePenultDetailedDemDiffVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_PENULT_DETAILED_DEM_DIFF_VISIBILITY_TOGGLED,
});

export const toggleDetailedDemDiffWithDGVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_DETAILED_DEM_WITH_DG_DIFF_VISIBILITY_TOGGLED,
});

export const enableGCPVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_GCP_VISIBILITY_ENABLED,
});

export const disableGCPVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_GCP_VISIBILITY_DISABLED,
});

export const enableQCVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_QC_VISIBILITY_ENABLED,
});

export const disableArchiveVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_ARCHIVE_VISIBILITY_DISABLED,
});

export const toggleAllVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_ALL_VISIBILITY_TOGGLED,
});

export const toggleShowFlightMarkerLabels = (): IAction<void> => ({
  payload: null,
  type: UI_SHOW_FLIGHT_MARKER_LABELS_TOGGLED,
});

export const enableAllVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_ALL_VISIBILITY_ENABLED,
});

export const toggleExistingVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_EXISTING_VISIBILITY_TOGGLED,
});

export const toggleProblemVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_PROBLEM_VISIBILITY_TOGGLED,
});

export const enableExistingVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_EXISTING_VISIBILITY_ENABLED,
});

export const enableProblemVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_PROBLEM_VISIBILITY_ENABLED,
});

export const toggleRadius = (radius: number): IAction<number> => ({
  payload: radius,
  type: UI_GCP_RADIUS_TOGGLED,
});

export const toggleNewNailAddition = (): IAction<void> => ({
  payload: null,
  type: UI_NEW_NAIL_ADDITION_TOGGLED,
});

export const disableNewNailAddition = (): IAction<void> => ({
  payload: null,
  type: UI_NEW_NAIL_ADDITION_DISABLED,
});

export const toggleGCPMailComposerVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_MAIL_COMPOSER_GCP_VISIBILITY_TOGGLED,
});

export const toggleSidebarVisibility = (): IAction<void> => ({
  payload: null,
  type: UI_SIDEBAR_VISIBILITY_TOGGLED,
});

export interface IDeprecatedUIState {
  activeNailId: string;
  allIsVisible: boolean;
  archiveIsVisible: boolean;
  demDiffWithDGIsVisible: boolean;
  demDiffWithPenultScanIsVisible: boolean;
  demDiffWithPreviousScanIsVisible: boolean;
  elevationMapIsVisible: boolean;
  flightMarkerActionsMenuIsVisible: boolean;
  gcpIsVisible: boolean;
  mailComposerGCPIsLoading: boolean;
  mailComposerGCPIsVisible: boolean;
  gcpRadius: number | null;
  newNailAdditionEnabled: boolean;
  problemIsVisible: boolean;
  existingIsVisible: boolean;
  qcIsVisible: boolean;
  showFlightMarkerLabelsIsOn: boolean;
  sidebarIsVisible: boolean;
}

const defaultState: IDeprecatedUIState = {
  activeNailId: null,
  allIsVisible: false,
  archiveIsVisible: false,
  demDiffWithDGIsVisible: false,
  demDiffWithPenultScanIsVisible: false,
  demDiffWithPreviousScanIsVisible: false,
  elevationMapIsVisible: false,
  flightMarkerActionsMenuIsVisible: false,
  gcpIsVisible: true,
  mailComposerGCPIsLoading: false,
  mailComposerGCPIsVisible: false,
  gcpRadius: null,
  newNailAdditionEnabled: false,
  problemIsVisible: false,
  existingIsVisible: false,
  qcIsVisible: false,
  showFlightMarkerLabelsIsOn: false,
  sidebarIsVisible: true,
};

export default function (
  state: IDeprecatedUIState = defaultState,
  action: IAction<any>,
): IDeprecatedUIState {
  switch (action.type) {
    case UI_FLIGHT_MARKER_ACTIONS_MENU_HIDDEN:
      return {
        ...state,
        flightMarkerActionsMenuIsVisible: false,
      };
    case UI_OVERLAY_MODE_TOGGLED:
      return {
        ...state,
        elevationMapIsVisible: !state.elevationMapIsVisible,
      };
    case UI_PREVIOUS_DETAILED_DEM_DIFF_VISIBILITY_TOGGLED:
      return {
        ...state,
        demDiffWithPreviousScanIsVisible:
          !state.demDiffWithPreviousScanIsVisible,
        demDiffWithPenultScanIsVisible: false,
        demDiffWithDGIsVisible: false,
      };
    case UI_PENULT_DETAILED_DEM_DIFF_VISIBILITY_TOGGLED:
      return {
        ...state,
        demDiffWithPreviousScanIsVisible: false,
        demDiffWithPenultScanIsVisible: !state.demDiffWithPenultScanIsVisible,
        demDiffWithDGIsVisible: false,
      };
    case UI_DETAILED_DEM_WITH_DG_DIFF_VISIBILITY_TOGGLED:
      return {
        ...state,
        demDiffWithPreviousScanIsVisible: false,
        demDiffWithPenultScanIsVisible: false,
        demDiffWithDGIsVisible: !state.demDiffWithDGIsVisible,
      };

    case UI_GCP_VISIBILITY_ENABLED:
      return {
        ...state,
        gcpIsVisible: true,
      };
    case UI_GCP_VISIBILITY_DISABLED:
      return {
        ...state,
        gcpIsVisible: false,
      };
    case UI_QC_VISIBILITY_ENABLED:
      return {
        ...state,
        qcIsVisible: true,
      };
    case UI_ARCHIVE_VISIBILITY_DISABLED:
      return {
        ...state,
        archiveIsVisible: false,
      };
    case UI_ALL_VISIBILITY_TOGGLED:
      return {
        ...state,
        allIsVisible: !state.allIsVisible,
      };
    case UI_ALL_VISIBILITY_ENABLED:
      return {
        ...state,
        allIsVisible: true,
      };
    case UI_SHOW_FLIGHT_MARKER_LABELS_TOGGLED:
      return {
        ...state,
        showFlightMarkerLabelsIsOn: !state.showFlightMarkerLabelsIsOn,
      };
    case UI_EXISTING_VISIBILITY_TOGGLED:
      return {
        ...state,
        existingIsVisible: !state.existingIsVisible,
      };
    case UI_EXISTING_VISIBILITY_ENABLED:
      return {
        ...state,
        existingIsVisible: true,
      };
    case UI_PROBLEM_VISIBILITY_TOGGLED:
      return {
        ...state,
        problemIsVisible: !state.problemIsVisible,
      };
    case UI_PROBLEM_VISIBILITY_ENABLED:
      return {
        ...state,
        problemIsVisible: true,
      };
    case UI_ACTIVE_NAIL_SELECTED:
      return {
        ...state,
        activeNailId: action.payload,
      };
    case UI_GCP_RADIUS_TOGGLED:
      return {
        ...state,
        gcpRadius: action.payload === state.gcpRadius ? null : action.payload,
      };
    case UI_NEW_NAIL_ADDITION_TOGGLED:
      return {
        ...state,
        newNailAdditionEnabled: !state.newNailAdditionEnabled,
      };
    case UI_NEW_NAIL_ADDITION_DISABLED:
      return {
        ...state,
        newNailAdditionEnabled: false,
      };
    case UI_MAIL_COMPOSER_GCP_VISIBILITY_TOGGLED:
      return {
        ...state,
        mailComposerGCPIsVisible: !state.mailComposerGCPIsVisible,
      };
    case UI_SIDEBAR_VISIBILITY_TOGGLED:
      return {
        ...state,
        sidebarIsVisible: !state.sidebarIsVisible,
      };
    default:
      return state;
  }
}
